import IllumioDomUtils from "../common/dom_utils.js";

export class SoftwareUpgradePathModel {
    constructor() {
        function initialize() {
            const UPGRADE_PATH_OBJ = {}
            $.ajax({
                dataType: 'json',
                method: 'get',
                contentType: 'application/json; charset=utf-8',
                url: '/api/v1/software/upgrade_path',
                async: false,
                error: function(response) {
                    console.log(response) 
                },
                success: function(data) {
                    UPGRADE_PATH_OBJ['data'] = data
                },
            });

            UPGRADE_PATH_OBJ['dimensions'] = get_dimensions();
            UPGRADE_PATH_OBJ['min_version'] = '17.1.0';

            function get_dimensions() {
                return {
                    'width': 1000,
                    'height': 500,
                    'border': {
                        'left': 90,
                        'right': 90,
                        'top': 50,
                        'bottom': 50,
                    },
                    'font': {
                        // pixels
                        'height': 13.5,

                    },
                    'tooltip': {
                        'horizontal_spacing': 44,
                        'vertical_spacing': 4,
                        'padding': {
                            'horizontal': 30,
                            'vertical': 20
                        },
                        'border-radius': 2,
                        'warning_icon': {
                            'height': 14
                        },
                        'tail_length': 8,
                        'tail_offset': 30
                    },
                    'nodes': {
                        'arrow': {
                            'length': 15
                        },
                        'tooltip_icon': {
                            'width': 16
                        },
                        'label': {
                            'y-offset': -12
                        },
                        'radius': 7
                    }
                }
            }
            return UPGRADE_PATH_OBJ;
        }
        initialize.bind(this);
        this.data = initialize();
    }
}

export class SoftwareUpgradePathView {
    constructor(model) {
        this.model = model;
        
        // To be set by the caller (container of the upgrade path)
        this.upgradePathElement = null;
        
        this.svgElement = null;
    }
    
    /**
     * Build upgrade path content.
     */
    createChildren() {
        if (this.upgradePathElement) {
            const upgradePathDiagramTemplateElement = document.getElementById('upgradePathDiagramTemplate');
            if (upgradePathDiagramTemplateElement) {
                this.svgElement = upgradePathDiagramTemplate.cloneNode(true);
                this.svgElement.id = 'upgradePathDiagram-' + new Date().getTime(); // TODO: Replace id with product name and/or download type.

                if (this.svgElement.classList) {
                    this.svgElement.classList.remove('hidden');
                } else {
                    // IE11 hacks (SVG element does not have classList attribute)
                    const classList = this.svgElement.getAttribute('class');
                    const classes = classList.split(/ /);
                    for (let i=classes.length-1;i>=0;i--) { 
                        if (classes[i]==='hidden') {
                            classes.splice(i, 1);
                        }
                    }
                    // this.svgElement.className = classes.join(' ');
                    this.svgElement.setAttribute('class', classes.join(' '));
                }
                
                IllumioDomUtils.removeChildren(this.upgradePathElement);
                this.upgradePathElement.appendChild(IllumioDomUtils.createSimpleTextBlock('h3', 'Upgrade Path'));
                this.upgradePathElement.appendChild(this.svgElement);
                this.upgradePathElement.classList.remove('hidden');
            } else {
                console.error('SoftwareUpgradePathView: createChildren(): Missing svg element of id upgradePagDiagramTemplate.');
            }
        } else {
            console.warn('SoftwareUpgradePathView: createChildren(): Missing this.upgradePathElement.');
        }
    }
    
    /**
     * Public method
     */
    render(software_type, from_version, to_version) {
        this.model.software_type = software_type || this.model.software_type;
        this.model.from_version = from_version || this.model.from_version;
        this.model.to_version = to_version || this.model.to_version;
        const UPGRADE_PATH_OBJ = this.model.data;

        function update_upgrade_path_description(html) {
            $('#resultContainer').show()
            $('#upgradePathDescription').html(html)
        }

        function generate_upgrade_path(software_type,from_version,to_version) {
            // Avoiding classes because IE doesn't support them, so treat this like a class
            UPGRADE_PATH_OBJ['request'] = {
                'from_version': from_version,
                'to_version': to_version,
                'software_type': software_type
            }

            UPGRADE_PATH_OBJ['to_version_list'] = []
            UPGRADE_PATH_OBJ['from_version_list'] = []
            for (let version in UPGRADE_PATH_OBJ['data'][software_type]) {
                UPGRADE_PATH_OBJ['from_version_list'].push(version)
                if (UPGRADE_PATH_OBJ['data'][software_type][version]['download_enabled']) {
                    UPGRADE_PATH_OBJ['to_version_list'].push(version)
                }
            }
            UPGRADE_PATH_OBJ['paths'] = {
                'upgrade': get_upgrade_path(software_type, from_version, to_version),
                'forbidden': get_forbidden_paths(to_version, UPGRADE_PATH_OBJ['to_version_list']),
                'future': get_future_paths(to_version, UPGRADE_PATH_OBJ['to_version_list'])
            }

            if (!UPGRADE_PATH_OBJ['paths']['upgrade']) {
                update_upgrade_path_description('PCE cannot be upgraded from '+from_version+' to '+to_version+'.')
                return []
            } else {
                update_upgrade_path_description('Below is the upgrade path. You must install each intermediate version(s), if applicable.')
            }

            if (UPGRADE_PATH_OBJ['main_group']) {
                UPGRADE_PATH_OBJ['main_group'].remove();
            }
            if (!this.svgElement) {
                this.createChildren();
            }
            const svgElement = this.svgElement;
            UPGRADE_PATH_OBJ['svg'] = d3.select(`#${svgElement.id}`);
            UPGRADE_PATH_OBJ['background'] = document.getElementById(svgElement.id).children[0];
            UPGRADE_PATH_OBJ['main_group'] = UPGRADE_PATH_OBJ['svg']
                .append('g')
                .attr('id', 'main_group')
                .attr('transform', `translate(0, ${UPGRADE_PATH_OBJ['dimensions']['border']['top']})`);

            UPGRADE_PATH_OBJ['trains'] = get_trains();
            UPGRADE_PATH_OBJ['scalers'] = get_scalers();

            draw_grid();
            draw_nodes();
            draw_legend();

            UPGRADE_PATH_OBJ['background'].onclick = hide_tooltip;

            function hide_tooltip() {
                if (UPGRADE_PATH_OBJ['tooltip']) {
                    if (UPGRADE_PATH_OBJ['tooltip']['node'].type != 'upgrade') {
                        UPGRADE_PATH_OBJ['tooltip']['node_group'].attr('style','opacity:0.5');
                    }
                    UPGRADE_PATH_OBJ['tooltip']['tooltip_group'].remove();
                    UPGRADE_PATH_OBJ['tooltip'] = null;
                }
            }

            function draw_nodes() {
                const nodes = create_node_data()
                const nodes_group = create_nodes_group()
                let target_node = null;
                let bottom_branches = 0;
                const nodes_by_level = {};
                for (let i in nodes) {
                    if (target_node) {
                        if (target_node.y != nodes[i].y) {
                            bottom_branches += 1;
                        }
                        if (!nodes_by_level[nodes[i].y]) {
                            nodes_by_level[nodes[i].y] = [];
                        }
                        nodes_by_level[nodes[i].y].push(nodes[i]);
                    }
                    if (nodes[i].version == UPGRADE_PATH_OBJ['request']['to_version']) {
                        target_node = nodes[i];
                    }
                }

                const node_group_arr = [];
                let target_node_seen = false;
                let x_offset_increment;
                let x_offset;
                if (bottom_branches > 1) {
                    x_offset_increment = -14/(bottom_branches-1);
                    x_offset = 7;
                } else {
                    x_offset = 0;
                }

                for (let i in nodes) {
                    let node_group = create_node_group(nodes_group, nodes[i]);
                    let node_icon = draw_node_icon(node_group, nodes[i]);
                    let node_label = draw_node_label(node_group, nodes[i]);

                    if (i > 0) {
                        if (target_node_seen) {
                            let y_offset = 0;
                            let x_index_by_train = nodes_by_level[nodes[i].y].indexOf(nodes[i]);
                            if (x_index_by_train > 0) {
                                y_offset += 40 * x_index_by_train;
                            }

                            if (nodes[i].y != target_node.y) {
                                draw_arrow(node_group, target_node, nodes[i], x_offset, y_offset);
                                if (bottom_branches > 1) {
                                    x_offset += x_offset_increment;
                                }
                            } else {
                                draw_arrow(node_group, target_node, nodes[i], 0, y_offset);
                            }

                        } else {
                            draw_arrow(node_group, nodes[i-1], nodes[i], 0, 0);
                        }
                    }
                    if (nodes[i].type == 'forbidden' || (nodes[i].type == 'upgrade' && Object.keys(UPGRADE_PATH_OBJ['data'][UPGRADE_PATH_OBJ['request']['software_type']][nodes[i]['version'].split('+')[0]]['compatibility'] || []).length > 0)) {
                        const tooltip_icon = draw_tooltip_icon(node_group, node_label, nodes[i]);
                        node_group.on('click', draw_tooltip.bind(null,node_group, tooltip_icon, nodes, nodes[i]));
                    }
                    if (nodes[i] == target_node) {
                        target_node_seen = true;
                    }
                }
                function draw_tooltip(node_group, tooltip_icon, nodes, node) {
                    hide_tooltip();
                    node_group.attr('style', 'opacity: 1');

                    const tooltip_group = create_tooltip_group();
                    // Draw the background first due to z-index
                    const tooltip_background = draw_tooltip_background(tooltip_group);
                    if (node.type == 'forbidden') {
                        draw_forbidden_tooltip();
                    } else {
                        draw_compatibility_tooltip();
                    }
                    function draw_forbidden_tooltip() {
                        let maximum_x = 0;
                        let maximum_y = 0;
                        
                        // "PCE cannot be upgraded from "
                        let texts = [];
                        for (let i in nodes) {
                            if (nodes[i].label == node.label) {
                                texts.push("PCE cannot be upgraded from");
                                texts.push(nodes[i-1].label + " to " + node.label);
                                break;
                            }
                        }

                        // The baseline for text in SVG is the bottom left corner, so we need to add the text-height to simulate it being in the top left instead
                        let y = UPGRADE_PATH_OBJ['dimensions']['font']['height']*2 + UPGRADE_PATH_OBJ['dimensions']['tooltip']['padding']['vertical'];
                        let x = UPGRADE_PATH_OBJ['dimensions']['tooltip']['padding']['horizontal'] + UPGRADE_PATH_OBJ['dimensions']['tooltip']['horizontal_spacing']/2;

                        const tooltip_texts = [];
                        for (let i in texts) {
                            let tooltip_text = draw_tooltip_text(tooltip_group, texts[i], x, y);
                            y += UPGRADE_PATH_OBJ['dimensions']['font']['height'] + UPGRADE_PATH_OBJ['dimensions']['tooltip']['vertical_spacing'];
                            tooltip_texts.push(tooltip_text);
                        }

                        let tooltip_width = 250;

                        if (tooltip_width < 200) {
                            draw_release_notes_link(tooltip_group, node, tooltip_width/2, y);
                            maximum_y += UPGRADE_PATH_OBJ['dimensions']['font']['height'] + UPGRADE_PATH_OBJ['dimensions']['tooltip']['vertical_spacing'];
                            y += UPGRADE_PATH_OBJ['dimensions']['font']['height'] + UPGRADE_PATH_OBJ['dimensions']['tooltip']['vertical_spacing'];
                        }

                        let tooltip_height = y + UPGRADE_PATH_OBJ['dimensions']['tooltip']['padding']['vertical'] - UPGRADE_PATH_OBJ['dimensions']['font']['height'] - UPGRADE_PATH_OBJ['dimensions']['tooltip']['vertical_spacing'];

                        for (let i in tooltip_texts) {
                            tooltip_texts[i].attr('x',tooltip_width/2);
                        }

                        draw_tooltip_title(tooltip_group, 'Forbidden path',tooltip_width);
                        
                        move_tooltip(node_group, node, tooltip_icon, tooltip_width, tooltip_height);

                        // We had to draw this first due to z-index so we adjust its position now
                        tooltip_background
                            .attr('width',tooltip_width)
                            .attr('height',tooltip_height);

                        UPGRADE_PATH_OBJ['tooltip'] = {'node': node, 'node_group':node_group, 'tooltip_group': tooltip_group}
                    }

                    function draw_compatibility_tooltip() {
                        const sorted_compatability_types = ['ven', 'ui', 'cli', 'flowlink', 'nen'];
                        const software_type_labels = get_software_type_labels();
                        const compatibilities = UPGRADE_PATH_OBJ['data'][UPGRADE_PATH_OBJ['request']['software_type']][node['version']]['compatibility'];
                        let x = UPGRADE_PATH_OBJ['dimensions']['tooltip']['padding']['horizontal'];
                        let maximum_x = 0;
                        let maximum_y = 0;
                        
                        for (let i in sorted_compatability_types) {
                            const software_type = sorted_compatability_types[i];
                            if (!compatibilities[software_type]) {
                                continue;
                            }

                            // The baseline for text in SVG is the bottom left corner, so we need to add the text-height to simulate it being in the top left instead
                            let y = UPGRADE_PATH_OBJ['dimensions']['font']['height']*2 + UPGRADE_PATH_OBJ['dimensions']['tooltip']['padding']['vertical'];
                            x += UPGRADE_PATH_OBJ['dimensions']['tooltip']['horizontal_spacing']/2;

                            // Draw compatibility title
                            draw_tooltip_text(tooltip_group, software_type_labels[software_type] || software_type.toUpperCase(), x, y);
                            y += UPGRADE_PATH_OBJ['dimensions']['font']['height'] + UPGRADE_PATH_OBJ['dimensions']['tooltip']['vertical_spacing'];

                            // Draw pce compatibilities 
                            const sorted_compatability_keys = Object.keys(compatibilities[software_type]).sort().reverse();

                            for (let i = 0; i < sorted_compatability_keys.length; i++) {
                                let compatibility_text = draw_tooltip_text(tooltip_group,''+sorted_compatability_keys[i],x,y);
                                if (compatibilities[software_type][sorted_compatability_keys[i]] == 'last_major') {
                                    draw_compatibility_warning_icon(tooltip_group,x + compatibility_text.node().getComputedTextLength()/2,y);
                                }
                                y += UPGRADE_PATH_OBJ['dimensions']['font']['height'] + UPGRADE_PATH_OBJ['dimensions']['tooltip']['vertical_spacing'];
                            }

                            // Now that you know the width you need, move everything to the appropriate x position
                            x += UPGRADE_PATH_OBJ['dimensions']['tooltip']['horizontal_spacing']/2 + UPGRADE_PATH_OBJ['dimensions']['tooltip']['horizontal_spacing']

                            // Record the dimensions of this block so we can use it later
                            maximum_x = Math.max(maximum_x,x);
                            maximum_y = Math.max(maximum_y,y);
                        }

                        const draw_release_summary = (node.version > '17.1.4+H14' && UPGRADE_PATH_OBJ['to_version_list'].indexOf(node.version) != -1);
                        let tooltip_width = maximum_x + UPGRADE_PATH_OBJ['dimensions']['tooltip']['padding']['horizontal'] - UPGRADE_PATH_OBJ['dimensions']['tooltip']['horizontal_spacing'];
                        if (tooltip_width < 250 || draw_release_summary == false) {
                            draw_release_notes_link(tooltip_group, node, tooltip_width/2, maximum_y);
                            maximum_y += UPGRADE_PATH_OBJ['dimensions']['font']['height'] + UPGRADE_PATH_OBJ['dimensions']['tooltip']['vertical_spacing'];
                            if (draw_release_summary) {
                                draw_release_summary_link(tooltip_group, node, tooltip_width/2, maximum_y);
                                maximum_y += UPGRADE_PATH_OBJ['dimensions']['font']['height'] + UPGRADE_PATH_OBJ['dimensions']['tooltip']['vertical_spacing'];
                            }
                        } else {
                            draw_release_notes_link(tooltip_group, node, tooltip_width/3, maximum_y);
                            if (draw_release_summary) {
                                draw_release_summary_link(tooltip_group, node, tooltip_width*2/3, maximum_y);
                            }
                            maximum_y += UPGRADE_PATH_OBJ['dimensions']['font']['height'] + UPGRADE_PATH_OBJ['dimensions']['tooltip']['vertical_spacing']
                        }

                        let tooltip_height = maximum_y + UPGRADE_PATH_OBJ['dimensions']['tooltip']['padding']['vertical'] - UPGRADE_PATH_OBJ['dimensions']['font']['height'] - UPGRADE_PATH_OBJ['dimensions']['tooltip']['vertical_spacing'];

                        draw_tooltip_title(tooltip_group, 'Compatibility', tooltip_width);
                        
                        move_tooltip(node_group, node, tooltip_icon, tooltip_width, tooltip_height);

                        // We had to draw this first due to z-index so we adjust its position now
                        tooltip_background
                            .attr('width',tooltip_width)
                            .attr('height',tooltip_height);

                        UPGRADE_PATH_OBJ['tooltip'] = {'node': node, 'node_group':node_group, 'tooltip_group': tooltip_group};
                    }

                    function get_software_type_labels() {
                        return {
                            'ven': 'VEN',
                            'ui': 'UI',
                            'nen': 'NEN',
                            'cli': 'CLI',
                            'flowlink': 'Flowlink'
                        };
                    }

                    function create_tooltip_group() {
                        return UPGRADE_PATH_OBJ['main_group']
                            .append('g')
                            .attr('class','upgrade_path_tooltip');
                    }
                    function draw_tooltip_background(tooltip_group) {
                        return tooltip_group
                            .append('rect')
                            .attr('fill','#2f3b4c')
                            .attr('rx',UPGRADE_PATH_OBJ['dimensions']['tooltip']['border-radius']);
                    }
                    function draw_tooltip_title(tooltip_group, text, tooltip_width) {
                        const title_text = tooltip_group
                            .append('text')
                            .text(text)
                            .attr('fill', '#64b5f6')
                            .attr('style', 'font-weight: bold;')
                            .attr('x', tooltip_width/2) 
                            .attr('y',UPGRADE_PATH_OBJ['dimensions']['font']['height'] + UPGRADE_PATH_OBJ['dimensions']['tooltip']['vertical_spacing']);

                        const title_underline = tooltip_group
                            .append('rect')
                            .attr('fill', '#64b5f6')
                            .attr('height', 2)
                            .attr('width', tooltip_width - 20)
                            .attr('x', 10)
                            .attr('y', UPGRADE_PATH_OBJ['dimensions']['font']['height']*1.5 + UPGRADE_PATH_OBJ['dimensions']['tooltip']['vertical_spacing']);

                        return title_text;
                    }
                    function draw_tooltip_text(tooltip_group, text, x, y) {
                        return tooltip_group
                            .append('text')
                            .text(text)
                            .attr('x',x)
                            .attr('y',y);
                    }
                    function draw_compatibility_warning_icon(tooltip_group, x, y) {
                        return tooltip_group
                            .append('image')
                            .attr('x',x+2)
                            .attr('y',y-UPGRADE_PATH_OBJ['dimensions']['font']['height'] + 2)
                            .attr("href", "/warning.svg")
                            .attr("style", "height:"+(UPGRADE_PATH_OBJ['dimensions']['font']['height'] - 1.5)+"px;");
                    }
                    function draw_release_notes_link(tooltip_group, node, x, y) {
                        // Special case
                        if (node.version == '18.3.0') {
                            return null;
                        }
                        return tooltip_group.append('a')
                            .attr('target', '_')
                            .attr('href', generate_release_notes_link(node.version))
                            .append('text')
                            .text("Release Notes")
                            .attr('x', x)
                            .attr('y', y)
                            .attr('fill', '#90caf9');
                    }
                    function draw_release_summary_link(tooltip_group, node, x, y) {
                        return tooltip_group.append('a')
                            .attr('target', '_')
                            .attr('href', generate_release_summary_link(node.version, node.label))
                            .append('text')
                            .text("Release Summary")
                            .attr('x', x)
                            .attr('y', y)
                            .attr('fill', '#90caf9');
                    }
                    function generate_release_notes_link(version) {
                        const version_parts = version.split('+')[0].split('.')
                         if (version == '18.2.0') {
                            return "/documentation/18.2/Illumio_ASP_18.2_Release_Notes.htm";
                        } else if (version_parts[0] == '17' || (version_parts[0] == '18' && version_parts[1] == '1') ){
                            return "/documentation/" + version_parts[0] + "." + version_parts[1] + "/Illumio_ASP_Release_Notes_" + version_parts[0] + "." + version_parts[1] + ".htm";
                        } else if (version_parts[0] == '18' || (version_parts[0] == '19' && version_parts[1] < '3')) {
                            return "/documentation/" + version_parts[0] + "." + version_parts[1] + "." + version_parts[2] + "/Illumio_ASP_" + version_parts[0] + "." + version_parts[1] + "." + version_parts[2] + "_Release_Notes.htm";
                        } else {
                            return "https://docs.illumio.com/asp/" + version_parts[0] + "." + version_parts[1] + "/Content/Resources/PDF/Illumio_ASP_Release_Notes_" + version_parts[0] + "." + version_parts[1] + "." + version_parts[2] +".pdf";
                        }
                    }
                    function generate_release_summary_link(version, label) {
                        return "https://docs.illumio.com/asp/20.1/Content/Guides/upgrade-summary/upgrade-why-and-how.htm#"+version.split('+')[0].split('.').join('')+"PCE"+(label.split(' ')[1] == 'LTS' ? 'LTS':'Standard');
                    }
                    // function generate_whats_new_link(version) {
                    //     return 'https://docs.illumio.com/asp/'+version.split('.')[0] + '.' +version.split('.')[1]+'/Content/Guides/whats-new/_ch-whats-new-and-changed-in-this-release.htm'
                    // }
                    function draw_tooltip_tail(tooltip_group, reflect_offset_x, reflect_offset_y) {
                        let width = 5;
                        let height = 10;
                        let length = -UPGRADE_PATH_OBJ['dimensions']['tooltip']['tail_length'];
                        let offset = UPGRADE_PATH_OBJ['dimensions']['tooltip']['tail_offset'];

                        if (reflect_offset_y) {
                            height = -height;
                            offset = -offset;
                        }
                        if (reflect_offset_x) {
                            length = -length;
                            width = -width;
                        }

                        tooltip_group
                            .append('path')
                            .attr('fill', "#2f3b4c")
                            .attr('d', 'M'+width+','+-height+'L'+length+',0L'+width+','+height+'Z')
                            .attr('transform', 'translate('+reflect_offset_x+','+(reflect_offset_y+offset)+')');
                    }

                    function move_tooltip(node_group, node, tooltip_icon, tooltip_width, tooltip_height) {
                        let tooltip_x = UPGRADE_PATH_OBJ['dimensions'].border.left +
                                        +UPGRADE_PATH_OBJ['scalers']['x'](node['x']) + 
                                        +tooltip_icon.attr('x') +
                                        UPGRADE_PATH_OBJ['dimensions']['nodes']['tooltip_icon']['width'] +
                                        UPGRADE_PATH_OBJ['dimensions']['tooltip']['tail_length'];
                        
                        let tooltip_y = +UPGRADE_PATH_OBJ['scalers']['y'](node['y']) +
                                        +tooltip_icon.attr('y') + 
                                        UPGRADE_PATH_OBJ['dimensions']['nodes']['tooltip_icon']['width']/2 -
                                        UPGRADE_PATH_OBJ['dimensions']['tooltip']['tail_offset'];

                        // Recalculate tooltip x/y in case they go out of bounds
                        let reflect_x = false
                        let reflect_y = false

                        if (tooltip_x + tooltip_width > UPGRADE_PATH_OBJ['dimensions']['width']) {
                            reflect_x = true;
                            tooltip_x -= UPGRADE_PATH_OBJ['dimensions']['tooltip']['tail_length'] + UPGRADE_PATH_OBJ['dimensions']['tooltip']['tail_length'] + UPGRADE_PATH_OBJ['dimensions']['nodes']['tooltip_icon']['width'] + tooltip_width;
                        }

                        if (tooltip_y + tooltip_height > UPGRADE_PATH_OBJ['dimensions']['height'] - UPGRADE_PATH_OBJ['dimensions']['border']['bottom']) {
                            tooltip_y -= tooltip_height - UPGRADE_PATH_OBJ['dimensions']['tooltip']['tail_offset']*2;
                            reflect_y = true;
                        }

                        // Add/adjust the tail position while as well
                        let tooltip_tail = draw_tooltip_tail(tooltip_group, reflect_x ? tooltip_width : 0, reflect_y ? tooltip_height : 0);

                        tooltip_group
                            .attr('transform','translate('+ tooltip_x + ','+ tooltip_y + ')');
                    }

                }
                function draw_arrow(node_group,node1,node2,x_offset,y_offset) {
                    // Note that these arrows are drawn relative to node 2, so a lot of the values will be negative
                    // They are drawn from node 2 in order to make the opacity highlighting work easier
                    let start_x = 0 - UPGRADE_PATH_OBJ['scalers']['x'](node2.x) + UPGRADE_PATH_OBJ['scalers']['x'](node1.x) + (node1.y == node2.y ? UPGRADE_PATH_OBJ['dimensions']['nodes']['radius'] : 0) + x_offset;
                    let start_y = 0 - UPGRADE_PATH_OBJ['scalers']['y'](node2.y) + UPGRADE_PATH_OBJ['scalers']['y'](node1.y) + (node1.y == node2.y ? 0 : UPGRADE_PATH_OBJ['dimensions']['nodes']['radius']);
                    let end_x = 0 - UPGRADE_PATH_OBJ['dimensions']['nodes']['radius'] - UPGRADE_PATH_OBJ['dimensions']['nodes']['arrow']['length'];
                    let end_y = 0;
                    node_group
                        .append('path')
                        .attr('class', 'arrow ' + node2['type'])
                        .attr('d',  d3.line().curve(d3.curveMonotoneX)(
                            [
                                [start_x, start_y],
                                [start_x, end_y + y_offset],
                                [end_x-30, end_y + y_offset],
                                [end_x-30, end_y],
                                [end_x, end_y]
                            ]));

                    node_group.append('use')
                        .attr('href', '#arrow_head')
                        .attr('class', node2['type'])
                        .attr('x', end_x)
                        .attr('y', end_y);
                }

                function create_node_data() {
                    const nodes = []
                    // Use train indexes as Y values
                    const train_obj = {}
                    for (let i in UPGRADE_PATH_OBJ['trains']) {
                        train_obj[UPGRADE_PATH_OBJ['trains'][i]] = i;
                    }
                    let x_value = 0;
                    let prev_y = null;
                    let total_paths = 0;
                    for (let path_type in UPGRADE_PATH_OBJ['paths']) {
                        total_paths += UPGRADE_PATH_OBJ['paths'][path_type].length;
                    }
                    for (let path_type in UPGRADE_PATH_OBJ['paths']) {
                        for (let i in UPGRADE_PATH_OBJ['paths'][path_type]) {
                            let train = UPGRADE_PATH_OBJ['paths'][path_type][i].split('.').slice(0,2).join('.');
                            let lts = UPGRADE_PATH_OBJ['data'][UPGRADE_PATH_OBJ['request']['software_type']][UPGRADE_PATH_OBJ['paths'][path_type][i]]['lts'];
                            let future = UPGRADE_PATH_OBJ['data'][UPGRADE_PATH_OBJ['request']['software_type']][UPGRADE_PATH_OBJ['paths'][path_type][i]]['future'];
                            let node = {
                                'label': UPGRADE_PATH_OBJ['paths'][path_type][i] + (lts ? ' LTS' : '') + (future ? ' (Future)' : ''),
                                'version': UPGRADE_PATH_OBJ['paths'][path_type][i],
                                // It's possible for your target path to be a future path. In this scenario, we need to update the path type
                                'type': path_type == 'upgrade' && future ? 'future' :path_type,
                                'y': train_obj[train],
                                'x': x_value,
                            }
                            x_value += 1;
                            prev_y = train_obj[train];
                            nodes.push(node);
                        }
                    }
                    return nodes
                }
                function create_nodes_group() {
                    return UPGRADE_PATH_OBJ['main_group']
                        .append('g')
                        .attr('id', 'nodes')
                        .attr('transform', 'translate(' + UPGRADE_PATH_OBJ['dimensions']['border']['left'] + ', 0)');
                }
                function create_paths_group() {
                    return UPGRADE_PATH_OBJ['main_group']
                        .append('g')
                        .attr('id', 'paths')
                        .attr('transform', 'translate(' + UPGRADE_PATH_OBJ['dimensions']['border']['left'] + ', 0)');
                }
                function create_node_group(nodes_group, node) {
                    const node_group = nodes_group
                        .append('g')
                        .attr('transform', 'translate(' + UPGRADE_PATH_OBJ['scalers']['x'](node['x']) + "," + UPGRADE_PATH_OBJ['scalers']['y'](node['y']) + ")");
                    if (node.type != 'upgrade') {
                        node_group
                            .attr('style', 'opacity: 0.5;')
                            .on('mouseover', function() {
                                this.style.opacity = '1'
                            })
                            .on('mouseout', function() {
                                if (!UPGRADE_PATH_OBJ['tooltip'] || this != UPGRADE_PATH_OBJ['tooltip']['node_group'].node()) {
                                    this.style.opacity = '0.5'
                                }
                            });
                    }
                    return node_group;
                }
                function draw_node_icon(node_group, node) {
                    let node_type = node['type'];
                    if (node['x'] == 0) {
                        node_type = 'starting';
                    } else if (node['x'] == UPGRADE_PATH_OBJ['paths']['upgrade'].length-1) {
                        node_type = 'target';
                    }
                    return node_group
                        .append('use')
                        .attr('href', '#' + node_type + '_node');
                }
                function draw_node_label(node_group, node) {
                    return node_group
                        .append('text')
                        .text(node['label'])
                        .attr("class", node['type'])
                        .attr("y", UPGRADE_PATH_OBJ['dimensions']['nodes']['label']['y-offset']);
                }
                function draw_tooltip_icon(node_group, node_label, node) {
                    return node_group
                        .append('image')
                        .attr('class', 'upgrade_path_tooltip_icon')
                        .attr("href", "/info.svg")
                        .attr('x', 0 + (node_label.node().getComputedTextLength() || (node.label.length * 9))/2 + 2)
                        .attr("y", 0 + UPGRADE_PATH_OBJ['dimensions']['nodes']['label']['y-offset'] - UPGRADE_PATH_OBJ['dimensions']['nodes']['tooltip_icon']['width'] + 2);
                }
            }

            function draw_legend() {
                const legend_contents = [
                {
                    'title': 'Starting Version',
                    'class': 'upgrade',
                    'href': 'starting_node'
                },
                {
                    'title': 'Required Steps',
                    'class': 'upgrade',
                    'href': 'upgrade_node' 
                },
                {
                    'title': 'Target Version',
                    'class': 'upgrade',
                    'href': 'target_node'
                }
                ,{
                    'title': 'Future Versions',
                    'class': 'future',
                    'href': 'future_node',
                    'strokeDashoffset': 2.5
                },
                {
                    'title': 'Unsupported Path',
                    'class': 'forbidden',
                    'href': 'forbidden_node',
                    'strokeDashoffset': 2
                },
                ];

                const legend = UPGRADE_PATH_OBJ['main_group']
                    .append('g')
                    .attr('id', 'legend')
                    .attr('transform', 'scale(0.8) translate(' + (UPGRADE_PATH_OBJ['dimensions']['width']*1.25 - 240 - 2) + ',' + (10-UPGRADE_PATH_OBJ['dimensions']['border']['top']) + ')');
                legend.append('rect')
                    .attr('class', 'legend_rect')
                    .attr('height', legend_contents.length * 20 + 20)
                    .attr('width', 240);

                for (let i in legend_contents) {
                    legend.append('text')
                        .text(legend_contents[i].title)
                        .attr('class', 'legend_text')
                        .attr('y', 25 + 20*i)
                        .attr('x', 95);
                    if (legend_contents[i].class) {
                        const path = legend.append('path')
                            .attr('class', legend_contents[i].class)
                            .attr('d', d3.line()([[10,20 + 20*i],[90,20 + 20*i]]));
                        if (legend_contents[i].strokeDashoffset) {
                            path.attr('style', 'stroke-dashoffset:' + legend_contents[i].strokeDashoffset);
                        }
                    }

                    if (legend_contents[i].href) {
                        legend.append('use')
                            .attr('class', legend_contents[i].class)
                            .attr('href', '#' + legend_contents[i].href)
                            .attr('width', 30)
                            .attr('x', 50)
                            .attr('y', 20 + 20 * i);
                    }
                }
            }

            function get_forbidden_paths(from_version, to_version_list) {
                const forbidden_paths = [];
                for (let i in to_version_list) {
                    if (to_version_list[i] > from_version) {
                        if (!get_upgrade_path(software_type, from_version, to_version_list[i])) {
                            forbidden_paths.push(to_version_list[i]);
                        }
                    }
                }
                return forbidden_paths;
            }

            function get_future_paths(from_version, to_version_list) {
                const future_paths = [];
                for (let i in to_version_list) {
                    if (to_version_list[i] > from_version && UPGRADE_PATH_OBJ['data'][software_type][to_version_list[i]]['future']) {
                        const path = get_upgrade_path(software_type, from_version, to_version_list[i]);
                        if (path && path.length == 2) {
                            future_paths.push(to_version_list[i]);
                        }

                    }
                }
                return future_paths;
            }

            function get_upgrade_path(software_type, from_version, to_version) {
                let possible_paths = [];
                // This will fill up the possible_paths array
                get_possible_paths(software_type, from_version, to_version, []);
                return select_optimal_path(software_type, possible_paths);

                function get_possible_paths(software_type, from_version, to_version, path) {
                    for (let i in UPGRADE_PATH_OBJ['data'][software_type][from_version]['upgrade_paths']) {
                        const version = UPGRADE_PATH_OBJ['data'][software_type][from_version]['upgrade_paths'][i];
                        // Check if it's in the array first 
                        if (version == to_version) {
                            // Filter out longer paths
                            const potential_path = path.concat(from_version).concat(version)
                            if (possible_paths.length == 0 || possible_paths[0].length == potential_path.length) {
                                possible_paths.push(potential_path);
                            } else if (possible_paths[0].length > potential_path.length){
                                possible_paths = [potential_path];
                            }
                            break;
                        } else if (version < to_version) {
                            // concat instead of push so it creates a clone rather than reference
                            get_possible_paths(software_type, version, to_version, path.concat(from_version));
                        }
                    }
                }
                function select_optimal_path(software_type, possible_paths) {
                    if (possible_paths.length == 0)
                        return null;
                    let optimal_path = possible_paths[0];
                    for (let i in possible_paths) {
                        for (let j = possible_paths[i].length-1; j >= 0; j--) {
                            if (UPGRADE_PATH_OBJ['data'][software_type][optimal_path[j]]['lts'] == false && UPGRADE_PATH_OBJ['data'][software_type][possible_paths[i][j]]['lts'] == true) {
                                optimal_path = possible_paths[i];
                            } else if (UPGRADE_PATH_OBJ['data'][software_type][optimal_path[j]]['lts'] == UPGRADE_PATH_OBJ['data'][software_type][possible_paths[i][j]]['lts']) {
                                if (UPGRADE_PATH_OBJ['data'][software_type][optimal_path[j]]['future'] == true && UPGRADE_PATH_OBJ['data'][software_type][possible_paths[i][j]]['future'] == false) {
                                    optimal_path = possible_paths[i];
                                } else {
                                    if (optimal_path[j] != possible_paths[i][j] && possible_paths[i][j] == get_larger_version(optimal_path[j],possible_paths[i][j])) {
                                        optimal_path = possible_paths[i];
                                    }
                                }
                            }
                        }
                    }
                    return optimal_path;
                }
                function get_larger_version(version_1,version_2) {
                    const version_1_parts = version_1.split(/[+H.]+/);
                    const version_2_parts = version_2.split(/[+H.]+/);
                    for (let i = 0; i < Math.max(version_1_parts.length, version_2_parts.length); i++) {
                        const version_1_part = +version_1_parts[i];
                        const version_2_part = +version_2_parts[i];
                        if (version_1_part == null) {
                            return version_1;
                        } else if (version_2_part == null) {
                            return version_2;
                        } else if (version_1_part > version_2_part) {
                            return version_1;
                        } else if (version_1_part < version_2_part) {
                            return version_2;
                        }
                    }
                }
            }

            function get_scalers() {
                const x_scaler = d3.scaleLinear().domain(d3.extent([0,UPGRADE_PATH_OBJ['paths']['upgrade'].length + UPGRADE_PATH_OBJ['paths']['forbidden'].length + UPGRADE_PATH_OBJ['paths']['future'].length-1])).range([0, UPGRADE_PATH_OBJ['dimensions'].width - UPGRADE_PATH_OBJ['dimensions'].border.right - UPGRADE_PATH_OBJ['dimensions'].border.left]);
                const y_scaler = d3.scaleLinear().domain(d3.extent([0,UPGRADE_PATH_OBJ['trains'].length-1])).range(
                    [UPGRADE_PATH_OBJ['dimensions'].height - UPGRADE_PATH_OBJ['dimensions'].border.top - UPGRADE_PATH_OBJ['dimensions'].border.bottom, 0]);
                return {'x': x_scaler, 'y': y_scaler};
            }

            // y values are the train
            function get_trains() {
                const trains = new Set();
                for (let path_type in UPGRADE_PATH_OBJ['paths']) {
                    for (let i in UPGRADE_PATH_OBJ['paths'][path_type]) {
                        trains.add(UPGRADE_PATH_OBJ['paths'][path_type][i].split('.').slice(0,2).join('.'));
                    }
                }
                // Essentially polyfilling this for IE11
                // return Array.from(trains).sort()
                const trains_arr = [];
                trains.forEach(function(item) {
                    trains_arr.push(item);
                })
                return trains_arr;
            }

            function draw_grid() {
                const grid_group = UPGRADE_PATH_OBJ['main_group']
                    .append('g')
                    .attr('id', 'grid');
                for (let i in UPGRADE_PATH_OBJ['trains'].reverse()) {
                    grid_group.append('text')
                        .text(UPGRADE_PATH_OBJ['trains'][i])
                        .attr('class', 'grid-label')
                        .attr('x', 0)
                        .attr('y', UPGRADE_PATH_OBJ['scalers']['y'](i) + UPGRADE_PATH_OBJ['dimensions']['font']['height']/2);
                    grid_group.append('path')
                    .attr('class', 'grid-line')
                    .attr('d', d3.line()([
                        [UPGRADE_PATH_OBJ['dimensions']['border']['left']/2, UPGRADE_PATH_OBJ['scalers']['y'](i)],
                        [UPGRADE_PATH_OBJ['dimensions']['width'] - UPGRADE_PATH_OBJ['dimensions']['border']['right']/2, UPGRADE_PATH_OBJ['scalers']['y'](i)]
                    ]));
                }
            }
        }

        generate_upgrade_path.bind(this, this.model.software_type,this.model.from_version,this.model.to_version)();
        function resize() {
            if (UPGRADE_PATH_OBJ['svg']) {
                UPGRADE_PATH_OBJ['svg'].node().style.height = document.getElementById('contentContainer').clientWidth/1000 * 500  + "px";
            }
        }
        return UPGRADE_PATH_OBJ['paths']['upgrade'];
    }
}

export class SoftwareUpgradePathController {
    constructor(model, view) {
        this.model = model;
        this.view = view;
        this.resizeCounter = 0;
        this.maxResizeChecks = 4;
        // Resizing only on window resize is not sufficient because it takes time for the dom elements to respond, use a timer instead
        this.resizeInterval = window.setInterval(this.resizeSVG.bind(this), 500);
        // Reset the interval now that the height has potentially changed
        $(window).resize(this.resetResizeInterval.bind(this));
    }

    resetResizeInterval() {
        this.resizeCounter = 0;
        clearInterval(this.resizeInterval);
        this.resizeInterval = window.setInterval(this.resizeSVG.bind(this), 500);
    }

    resizeSVG() {
        let new_height;
        if (this.view.svgElement) {
            this.view.svgElement.style.width = "100%";
            new_height = this.view.svgElement.clientWidth/1000 * 500  + "px";
        }
        if (this.view.svgElement && this.view.svgElement.style.height != new_height) {
            this.view.svgElement.style.height = this.view.svgElement.clientWidth/1000 * 500  + "px";
            this.resizeCounter = 0;
        } else {
            this.resizeCounter += 1;
        }
        // Keep track of how many times the height hasn't changed. After this.maxResizeChecks attempts, don't check anymore unless a resize is triggered
        if (this.resizeCounter >= this.maxResizeChecks) {
            clearInterval(this.resizeInterval);
        }
    }
}